import styled from 'styled-components';

const MobileFilterItemStyle = styled.div`
	border-bottom: 1px solid var(--grey);

	&.last {
		border-bottom: unset;
	}

	.title-wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: var(--sp2x) 0;
	}

	.items-wrap {
		height: 0;
		overflow: hidden;

		.inner-content-item {
			display: block;
			margin-bottom: var(--sp2x);
			width: fit-content;

			&.active {
				color: var(--green);
			}
		}

		&.active {
			height: 100%;
		}
	}

	.icon-arrow {
		transition: transform var(--trTime) ease-out;

		&.rotate {
			transform: rotate(180deg);
		}
	}
`;

export default MobileFilterItemStyle;
